module.exports = __webpack_public_path__ + "static/media/uWaterloo.63ff183b.svg";